import styled from 'styled-components'

export const Button = styled.button`
  display: flex;
  align-items: center;

  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  letter-spacing: 1px;
  text-decoration: none;
  text-align: center;

  justify-content: center;

  cursor: pointer;

  padding: 11px 27px 11px 27px;

  background-color: var(--light);
  border: 1px solid var(--light);
  background-color: ${props => props.backgroundColor || 'var(--light)'};
  border: ${props => props.backgroundColor || 'var(--light)'};
  border-radius: 50px;
  color: ${props => props.color || 'var(--text)'};
  transition: .3s;

  &.upperCase {
    text-transform: uppercase !important;
  }

  &.lg {
    padding: 16px 25px 16px 25px;
    min-width: 185px;
  }

  &.md {
    padding: 10px 20px 10px 20px;
  }

  &.sm {
    padding: 6px 20px 6px 20px;
  }

  &.bold {
    font-weight: bold;
  }

  &.fullWidth {
    width: 100%;
  }

  &.disabled {
    opacity: 0.5;
    border: 1px solid var(--light);
    cursor: not-allowed;
  }

  svg {
    pointer-events: none;
  }
`

export const IconLeft = styled.img`
  margin-right: 10px;
`

export const IconRight = styled.img`
  margin-left: 10px;
`
